import { formatINR } from "../../../lib/loanMath";

const fmt = (v, c) => {
  if (c.fmt === "text") return v ?? "—";
  if (c.fmt === "pct") return `${v ?? 0}%`;
  return formatINR(v ?? 0);
};

export function ChartDataTable({ columns, rows }) {
  return (
    <div className="overflow-x-auto max-h-[360px] overflow-y-auto border hairline rounded" data-testid="chart-data-table">
      <table className="w-full text-[11px] min-w-[720px]">
        <thead className="sticky top-0 bg-[hsl(var(--card))]">
          <tr className="text-left text-muted-foreground">
            {columns.map((c) => <th key={c.key} className="py-1.5 px-2 font-normal whitespace-nowrap">{c.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.label ?? i} className="border-t hairline" data-testid={`chart-table-row-${i}`}>
              {columns.map((c) => (
                <td key={c.key} className="py-1 px-2 tabular-nums whitespace-nowrap" data-testid={`chart-cell-${i}-${c.key}`}>
                  {fmt(r[c.key], c)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
